module.exports = __webpack_public_path__ + "img/kr-card-bottom-2.0e91f90.png";